import { Validator } from "../validator"

export enum FloorNumberError {
    BLANK = `address_error`,
}

const REGEX = /^[a-zA-Z0-9#-]+$/i
const MAX_LENGTH = 5
class FloorNumberValidator implements Validator<string, FloorNumberError> {
    validate(entry: string): FloorNumberError | undefined {
        if (entry === `` || entry.length > MAX_LENGTH || !REGEX.test(entry)) {
            return FloorNumberError.BLANK
        }
    }
}

export { FloorNumberValidator }